import styled from 'styled-components';

export const colors = {
    primary_color: '#4D2285',
    dark_purple: '#430A60',
    water_green: '#00787F',
    light_green: '#B1DBDD',
    light_blue: '#E3EBEC',
    light_purple: '#EDE5F6',
    black: '#101010',
    gray4: '#4C4C4C',
    gray3: '#D0D0D0',
    gray2: '#ECECEC',
    gray1: '#F3F3F3',
    white: '#FBFBFB',
    
    alert: '#D20000',
    success: '#207C00',
    
    modals_filter: 'rgba(16, 16, 16, 0.6)',
    drop_shadow_color: 'rgba(16, 16, 16, 0.08);',
    
};

export const Container = styled.div``